<app-top-bar-navigation [showBackButton]="true"  title="Troubleshooting Tips" (backBtnClicked)="back()" />
<div class="px-24 py-32">
  <span class="siq-text-400 fs-16 white"> {{havingIssuesCTA}} </span>
  <div class="py-48">
    <app-siq-list-items [items]="troubleshootingTips" itemsLayoutAlign="center center" textMargin="ml-12"/>
  </div>
  <span class="siq-text-400 fs-16 white"> {{contactUs}} </span>
</div>